<div class="toast-container">
  <div 
    *ngFor="let toast of toasts; trackBy: trackByToastId" 
    class="toast"
    [attr.data-id]="toast.id"
  >
    <span class="toast-message">{{ toast.message }}</span>
    <button 
      class="toast-close" 
      (click)="removeToast(toast.id)"
      title="Close"
    >
      ×
    </button>
  </div>
</div>